import { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import { isMeetingAccessible } from 'utility/oneOnOne';
import AsyncListTooltip from '../../../asyncListTooltip';
import ConditionalTooltip from '../../../conditionalTooltip';
import Meeting from './meeting';
import { IMPRESSION_VALUES } from '../../../../../constants/oneOnOne';
import MeetingModerator from './meetingModerator';

const useStyles = makeStyles(({ palette: { primary } }) => ({
  root: {
    backgroundColor: ({ report }) =>
      report?.impression
        ? IMPRESSION_VALUES[report.impression - 1].color
        : primary.white,
    borderRadius: '50%',
    alignSelf: 'center',
    height: 16,
    width: 16,
  },
  clickable: {
    cursor: 'pointer',
  },
  asyncTooltip: {
    minWidth: 200,
    maxWidth: 350,
  },
  tooltipViewport: {
    maxHeight: 221,
  },
  meetingWrapper: {
    display: 'flex',
    alignItems: 'center',
    maxWidth: 302,
  },
}));

const Report = ({
  translations,
  report = null,
  hasReport,
  onGetReport,
  onGoToMeetingDetails,
  canAccessUserProfileCheck,
  onGoToUserProfile,
}) => {
  const classes = useStyles({ report });

  const getVirtualMeetingItemSize = useCallback(
    (index, meetings) => (index === meetings.length - 1 ? 20 : 28),
    []
  );

  const renderMeetingItem = meeting => (
    <div className={classes.meetingWrapper}>
      <Meeting meeting={meeting} />
      <MeetingModerator
        meeting={meeting}
        canSeeUserProfile={canAccessUserProfileCheck}
        onClickHandler={onGoToUserProfile}
      />
    </div>
  );

  return hasReport ? (
    <AsyncListTooltip
      tooltipPopperClass={classes.asyncTooltip}
      tooltipWrapperClass={classes.tooltipViewport}
      title={translations.meetings}
      renderLabelItem={renderMeetingItem}
      getLabelData={onGetReport}
      getItemSize={getVirtualMeetingItemSize}
      isItemClickable={isMeetingAccessible}
      onItemClickHandler={onGoToMeetingDetails}
    >
      <div className={classNames(classes.root, classes.clickable)} />
    </AsyncListTooltip>
  ) : (
    <ConditionalTooltip message={translations.noMeeting} addTooltip>
      <div className={classes.root} />
    </ConditionalTooltip>
  );
};

Report.propTypes = {
  report: PropTypes.shape({}),
  hasReport: PropTypes.bool.isRequired,
  onGoToMeetingDetails: PropTypes.func.isRequired,
  onGetReport: PropTypes.func.isRequired,
  canAccessUserProfileCheck: PropTypes.func.isRequired,
  onGoToUserProfile: PropTypes.func.isRequired,
};

export default Report;
